import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarNav
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import DefaultHeader from './DefaultHeader';

import { connect } from "react-redux";

import { doLogout } from '../../store/actions/auth';

const mapDispatchToProps = dispatch => {
  return {
    doLogout: status => dispatch(doLogout())
  };
};


class ConnectedDefaultLayout extends Component {

  _doLogout() {
    this.props.doLogout();
  }

  render() {
    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarNav navConfig={navigation} {...this.props}/>
            <AppSidebarFooter style={{padding: 0}} >
              <a className="nav-link" onClick={() => this._doLogout()}><i className="icon-logout nav-icon" />Log out</a>
            </AppSidebarFooter>
          </AppSidebar>
          <main className="main">
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                    return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                        <route.component {...props} />
                      )} />)
                      : (null);
                  },
                )}
                <Redirect from="/" to="/logs" />
              </Switch>
            </Container>
          </main>
        </div>
      </div>
    );
  }
}

const DefaultLayout = connect(null, mapDispatchToProps)(ConnectedDefaultLayout);

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js